
var agi = agi || {};
agi.expressions = agi.expressions || {};

(function(Utils) {
    "use strict";

    var exp = function exp() {};

    var dependenciesLoaded = 0;
    var dependencies;
    var INIT_MODE = "init";
    var PREVIEW_MODE = "preview";
    var PICKUP_MODE = "pickup";
    var mgr;

    exp.env = {};
    exp.expression = {};

    //Start of a JL Video card! :)
    exp.init = function init(env, productData, helper) {

        window.addEventListener("resize", exp.scaleCanvas);

        exp.env = env;
        exp.productData = productData;
        exp.helper = helper;

        var imgPath = exp.env.imghost + exp.env.contentMainPath + "/img/";
        var assetPath = exp.env.imghost + exp.env.contentMainPath + "/misc/";

        //If there is a loader defined in the product data json, load that first before other dependencies
        if (productData.loader) {
            exp.load(productData.loader, exp.loaderCompleted.bind(this), exp.loaderCompleted.bind(this));
        }
        //Otherwise, just go load the regular dependencies
        else {
            if (productData.dependencies) {
                dependencies = productData.dependencies;
                exp.loadDependencies();
            } 
            else {
                exp.attachListeners();
            }
        }

	    // JLVideo needs to be instantiated before dependency
        // setup so that its CanvasController will be ready to handle
        // the product load callbacks.
        exp.mgr = new agi.expressions.JLVideo({
                  "env": exp.env,
                  "originalZIndex": 200,
                  "contentDetails": exp.productData,
                  "imgPath": imgPath,
                  "assetPath": assetPath,
                  "mode": exp.env.mode,
                  "expressionInst": exp.helper});
	
        //Make sure we have added our dependencies
        if (productData.dependencies) {
            dependencies = productData.dependencies;
        }
    };

    //Hide the content while the loader is showing
    exp.hideContent = function hideContent() {
        var intLayer = document.querySelector("#expression-interactive-layer");
        var videoLayer = document.querySelector("#expression-vid-player");
        var overlay = document.querySelector("#expression-overlay");
        
        intLayer.style.display = "none";
        videoLayer.style.visibility = "hidden";
        overlay.style.display = "none";
    }

    //On a window resize, call everybodys scaling function driven by JLVideo
    exp.scaleCanvas = function scaleCanvas() {
        if (exp.mgr != undefined) {
               exp.mgr.scaleContent(exp.env);
        }
    }

    /**
     *      * Callback for either "load" and "error" preloader events.
     */
    exp.loaderCompleted = function loaderCompleted(event) {
        exp.hideContent();
	    // load dependencies in either case.
        if (dependencies) {
            exp.loadDependencies();
        } else {
            exp.attachListeners();
        }
    }

    //Generic loader function with success and failure function handlers passed in
    exp.load = function load(file, successHandler, failureHandler) {
        var url = exp.env.imghost + file;
        if (url != undefined) {
            if (url.substring(0, 4) != "http") {
                url = this.env.imghost + url;
            }
            var extension = url.substr(url.lastIndexOf("."));
            if (extension === ".css") {
                Utils.loadCSSFile(url, successHandler.bind(this), failureHandler.bind(this));
            } else if (extension === ".js") {
                Utils.loadJavaScriptFile(url, successHandler.bind(this), failureHandler.bind(this));
            }
        }
    };

    //Get the dependencies of the product
    exp.loadDependencies = function loadDependencies() {
        exp.loadDependency(dependencies[dependenciesLoaded]);
    };

    exp.loadDependency = function loadDependency(dependency) {
        exp.load(dependency, exp.dependencyLoaded, exp.dependencyFailed);
    };

    //Once all dependencies are loaded, attach Expression listeners
    exp.dependencyLoaded = function dependencyLoaded(event) {
        if(++dependenciesLoaded !== dependencies.length) {
            exp.loadDependency(dependencies[dependenciesLoaded]);
        } else {
            exp.attachListeners();
        }
    };

    exp.dependencyFailed = function dependencyFailed(event) {
        var msg = "Failed to load Expression dependency. Cannot continue.";
        throw new Error(msg);
    };

    //Load the product using the environment product id
    exp.loadProduct = function loadProduct() {
        var id = exp.env.productId;
        var url = "/product/expressions/"+id+"/js/"+id+".js";
        exp.load(url, exp.productLoaded, exp.productFailed);
    };

    //Once the product is ready, fade out the loader
    exp.productLoaded = function productLoaded() {
	    //Product is ready, do nothing right now
    }

    //Error handler for loading product
    exp.productFailed = function productFailed() {
        var msg = "Failed to load " + exp.env.productId + ".js. ";
        msg += "Unable to continue.";
        throw new Error(msg);
    };

    exp.attachListeners = function attachListeners() {
        var Express = agi.expressions.Express;
        Express.dispatcher.addEventListener("expressionReady", exp.ready);
        Express.dispatcher.addEventListener("sendIsReady", exp.addSendButtonListeners);
        exp.loadProduct();
    };

    exp.ready = function ready() {
        exp.activateMode();
    };

    exp.activateMode = function activateMode() {
        // TODO implement
        switch(exp.env.mode) {
            case INIT_MODE:
                break;
            case PREVIEW_MODE:
            case PICKUP_MODE:
                break;
            default:
                throw new Error("Unknown product mode: " + exp.env.mode);
        }
    };

    agi.expressions.JLVideoExpressionManager = exp;

    exp.destroy = function destroy() {
        if (exp.mgr) {
            exp.mgr.destroy();
            exp.mgr = null;
        }
    };

    exp.replay = function replay() {
        exp.mgr.replayCard();
    };

    exp.skipToEnd = function skipToEnd() {
        exp.mgr.skipToEnd();
    };

    return {
        init: exp.init,
        destroy: exp.destroy,
        replay: exp.replay,
        skipToEnd: exp.skipToEnd
    }
}(agi.expressions.Utils));
